module.exports = __webpack_public_path__ + "static/media/korunky-rim.3fdc2473.jpg";